module.exports = __webpack_public_path__ + "static/media/Illus-Plate.1be038d6.png";